import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  return <section className="py-20 px-6 bg-white" data-id="element-133">
      <div className="max-w-3xl mx-auto" data-id="element-134">
        {/* Familiar Pain */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-20" data-id="element-135">
          <h2 className="text-3xl md:text-4xl font-serif text-charcoal mb-10 text-center" data-id="element-136">
            Si esto te suena familiar…
          </h2>

          <ul className="space-y-6 text-lg text-charcoal/80" data-id="element-137">
            <li className="flex items-start gap-4" data-id="element-138">
              <span className="text-warm-red text-2xl mt-1" data-id="element-139">•</span>
              <p data-id="element-140">Tu dinero entra… y se evapora.</p>
            </li>
            <li className="flex items-start gap-4" data-id="element-141">
              <span className="text-warm-red text-2xl mt-1" data-id="element-142">•</span>
              <p data-id="element-143">
                No es que no trabajes. Es que{' '}
                <strong className="text-charcoal" data-id="element-144">todo cae encima</strong>.
              </p>
            </li>
            <li className="flex items-start gap-4" data-id="element-145">
              <span className="text-warm-red text-2xl mt-1" data-id="element-146">•</span>
              <p data-id="element-147">
                Te prometiste "esta vez sí me organizo"… y a los 5 días ya estás
                improvisando.
              </p>
            </li>
            <li className="flex items-start gap-4" data-id="element-148">
              <span className="text-warm-red text-2xl mt-1" data-id="element-149">•</span>
              <p data-id="element-150">A veces gastas por cansancio y luego te castigas por eso.</p>
            </li>
            <li className="flex items-start gap-4" data-id="element-151">
              <span className="text-warm-red text-2xl mt-1" data-id="element-152">•</span>
              <p data-id="element-153">
                Y cada vez que ves "NSF fee", "overdraft", "late fee"… sientes
                que la vida te está cobrando por respirar.
              </p>
            </li>
          </ul>

          <div className="mt-10 p-6 bg-cream rounded-lg border-l-4 border-forest text-center" data-id="element-154">
            <p className="text-xl font-medium text-charcoal leading-relaxed" data-id="element-155">
              No necesitas que alguien te regañe. Necesitas un sistema que
              funcione cuando estás cansada.
            </p>
          </div>
        </motion.div>

        {/* Reframe */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-156">
          <h2 className="text-3xl md:text-4xl font-serif text-charcoal mb-6" data-id="element-157">
            El problema no es que gastes "mal"
          </h2>
          <p className="text-lg text-warm-gray mb-8" data-id="element-158">
            El problema es que estás viviendo sin una línea clara de seguridad.
            Sin una respuesta semanal.
          </p>

          <div className="space-y-4 text-lg text-charcoal/90 mb-10" data-id="element-159">
            <p data-id="element-160">Porque cuando no sabes qué es seguro gastar:</p>
            <ul className="inline-block text-left space-y-2 pl-4 border-l-2 border-warm-gray/30" data-id="element-161">
              <li data-id="element-162">te vuelves súper estricta (y revientas)</li>
              <li data-id="element-163">o te "das un respiro" (y pagas el precio)</li>
              <li data-id="element-164">o evitas mirar la cuenta (y el sistema te muerde después)</li>
            </ul>
          </div>

          <p className="text-2xl font-serif text-forest" data-id="element-165">
            Eso no es falta de disciplina.
            <br data-id="element-166" />
            Es{' '}
            <span className="underline decoration-warm-red/30 decoration-4 underline-offset-4" data-id="element-167">
              incertidumbre
            </span>
            .
          </p>
        </motion.div>
      </div>
    </section>;
}